





















































































































import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ACTION } from ".";
import {
  CustomersApi,
  GetCustomersResponse,
  GetLocationsCustomerResponse,
  LocationsApi,
  ApiMessage,
  LicensesApi,
} from "../../../apis";
import { AxiosResponse } from "axios";
import { Dictionary } from "lodash";
import moment from "moment";

@Component({ components: { ValidationObserver, ValidationProvider } })
export default class AddEditLicenseDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({}) mode: ACTION;
  @Prop({ default: {} }) selectedLicense: any;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  invalidMsgExpirationDate = null;
  get show() {
    return this.value;
  }
  getCustomersResponse: GetCustomersResponse = null;
  getLocationsCustomerResponse: GetLocationsCustomerResponse = null;

  get CUSTOMERS(): { text: string; value: string }[] {
    return this.getCustomersResponse
      ? this.getCustomersResponse.data.map((val) => ({
          value: val.id,
          text: val.companyName,
        }))
      : [];
  }

  get LOCATIONS() {
    return this.getLocationsCustomerResponse
      ? this.getLocationsCustomerResponse.data.map((val) => ({
          value: val.id,
          text: val.locationName,
        }))
      : [];
  }

  @Watch("selectedLicense.customer")
  async onCustomerIdWatch(newVal: string) {
    if (!newVal) return;
    this.getLocationsCustomerResponse = (
      await new CustomersApi().getActiveLocationsByCustomerId({
        id: this.selectedLicense.customer,
      })
    ).data;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get editMode() {
    return this.mode === ACTION.EDIT_LICENSE;
  }
  get newMode() {
    return this.mode === ACTION.NEW_LICENSE;
  }

  async onShow() {
    this.getCustomersResponse = (await new CustomersApi().getActiveCustomers()).data;
    // this.customerId = this.getCustomersResponse.data.id;
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  async onSubmit() {
    const isValid = await this.observer.validate();
    if (!isValid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    await this.doSubmit()
      .then((res) => this.handleSuccess())
      .catch((err) => this.handleFailed(err));
    this.$util.hideLoading();
  }

  doSubmit(): Promise<AxiosResponse> {
    if (this.newMode) {
      return new LicensesApi().createLicense({
        postLicenseRequest: {
          ...this.selectedLicense,
          registrationDate: moment(this.selectedLicense.registrationDate)
            .utc()
            .format("YYYY-MM-DD HH:mm"),
          expirationDate: this.selectedLicense.expirationDate ? moment(this.selectedLicense.expirationDate).utc()
            .format("YYYY-MM-DD HH:mm"): null,
        },
      });
    }
    if (this.editMode) {
      return new LicensesApi().updateLicense({
        id: this.selectedLicense.id,
        putLicenseRequest: {
          ...this.selectedLicense,
          registrationDate: moment(this.selectedLicense.registrationDate)
            .utc()
            .format("YYYY-MM-DD HH:mm"),
          expirationDate: this.selectedLicense.expirationDate ? moment(this.selectedLicense.expirationDate).utc()
            .format("YYYY-MM-DD HH:mm"): null,
        },
      });
    }
  }

  handleSuccess() {
    this.show = false;
  }

  handleFailed(err) {
    this.$util.showError(err);
  }
}
